
import { CheckCircle, Mail, ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"
import { DialogTitle, DialogDescription } from "@/components/ui/dialog"

interface OrderConfirmationProps {
  onReturn: () => void
  emailAddress: string
}

export function OrderConfirmation({ onReturn, emailAddress }: OrderConfirmationProps) {
  return (
    <div className="flex flex-col items-center">
      <DialogTitle className="text-center mb-4">
        <div className="flex justify-center mb-4">
          <CheckCircle className="h-16 w-16 text-green-500" />
        </div>
        <span className="text-3xl font-bold">Order Complete!</span>
      </DialogTitle>
      
      <DialogDescription className="text-lg text-center mb-6">
        Thank you for your purchase. We'll begin processing your cease and desist letter right away.
      </DialogDescription>
      
      <div className="bg-purple-50 p-4 rounded-lg mb-6 w-full">
        <h2 className="text-xl font-semibold mb-2 flex items-center gap-2">
          <Mail className="h-5 w-5 text-purple-600" />
          Check Your Email
        </h2>
        <p className="text-sm text-gray-700">
          We've sent the following emails to {emailAddress}:
        </p>
        <ul className="mt-2 text-sm text-gray-700 space-y-1 list-disc pl-5">
          <li>A payment receipt with your order details</li>
          <li>A confirmation email with a copy of your letter</li>
        </ul>
        <p className="text-sm text-gray-700 mt-2">
          If you don't see them, please check your spam or junk folder.
        </p>
      </div>
      
      <div className="text-center space-y-4 w-full">
        <Button 
          onClick={onReturn} 
          className="w-full"
          variant="default"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Return Home
        </Button>
        <p className="text-sm text-gray-500 mt-4">
          Have questions about your order? 
          <a href="/contact" className="text-purple-600 ml-1 hover:underline cursor-pointer">
            Contact us
          </a>
        </p>
      </div>
    </div>
  )
}
